<template>
  <div
    class="w-[90%] max-w-[1080px] bg-burgundy p-5 md:p-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    @click.stop
  >
    <button
      class="absolute top-3 right-4 md:top-4 w-11 aspect-square border border-pink rounded-full text-pink cursor-pointer hover:bg-pink hover:text-burgundy transition-[background-color_color] flex items-center justify-center"
      @click.stop="close"
    >
      <IconSprite id="close" />
    </button>

    <div class="grid gap-4 md:gap-6 sm:grid-cols-2 md:grid-cols-3 pt-12 md:pt-0 pr-0 md:px-8">
      <a
        v-for="(booking, bookingIndex) in bookings"
        :key="`booking-item-${bookingIndex}`"
        :href="booking.link"
        target="_blank"
        rel="noopener noreferrer"
        class="border border-pink p-2 md:p-2.5 bg-dustrose group"
      >
        <div class="border border-pink p-6 md:p-8 flex flex-col items-center">
          <ResponsiveImage :media="booking.image" class="w-12 h-12 object-contain mb-2" />
          <div class="flex md:flex-col items-center gap-2">
            <h3
              class="font-title uppercase text-xl leading-[1.05] text-center flex-1 flex items-center"
            >
              {{ booking.title }}
            </h3>
            <span>
              <ArrowButton class="-rotate-45 text-burgundy" />
            </span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'
import ArrowButton from '@/components/small/ArrowButton.vue'
import { useModalStore } from '@/stores/modal.ts'

export default {
  name: 'BookingPopup',
  components: { ArrowButton, IconSprite, ResponsiveImage },
  setup() {
    const store = useModalStore()

    return { bookings: store.data?.bookings, close: store.close }
  },
}
</script>
